export default __webpack_public_path__ + "static/3c35dc60-9fe3-480f-90ac-e453db0271e2-7e7d8dd5560c058bcc71ccf449ef043d.woff2";